import React, { memo } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/system";
import { ContainedButton } from "./ContainedButton";

const StyledButton = styled(ContainedButton)({
  width: "145px",
  minHeight: 40,
  borderRadius: "33px",
  padding: "8px 20px",
  backgroundColor: "#000",
  fontFamily: "DM Sans, sans-serif",
  lineHeight: "normal",
  letterSpacing: "normal",
  "& span": {
    justifyContent: "center",
    fontSize: "16px"
  }
});

const ContinueButtonBase = ({ label = "Continue", classes, ...rest }) => (
  <StyledButton label={label} {...rest} />
);
ContinueButtonBase.propTypes = {
  label: PropTypes.string,
  classes: PropTypes.object
};

export const ContinueButton = memo(ContinueButtonBase);
